import React, { useState } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { useTheme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { getContactFileUrl } from '../../contact-file/actions/get-contact-file-url';

import { UiButton } from '../../ui/ui-button';

import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    getContactFileUrl: (contactFileId: number) => dispatch(getContactFileUrl(contactFileId)),
  },
});

type InputProps = {
  contactFile: ContactFile;
  presignedUrl: string;
};

type DispatchProps = ReturnType<typeof mapDispatchToProps>;

type Props = InputProps & DispatchProps;

export const PREVIEWABLE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/svg+xml',
  'image/webp',
];

export const InlineContactFile = connect(
  undefined,
  mapDispatchToProps,
)(({ actions, contactFile, presignedUrl }: Props) => {
  const [isPreviewError, setIsPreviewError] = useState<boolean>(false);

  const theme = useTheme();
  const isOnMobile = useMediaQuery(theme.breakpoints.down('xs'));

  const handlePreviewError = () => setIsPreviewError(true);

  const handleDownloadImage = (contactFileId: number) => async () => {
    const { contactFileUrl } = await actions.getContactFileUrl(contactFileId);
    window.open(contactFileUrl, '_blank');
  };

  const { contactFileId, fileName, mimeType } = contactFile;

  const isPreviewable = mimeType && PREVIEWABLE_MIME_TYPES.includes(mimeType);

  return isPreviewable && !isPreviewError ? (
    <img
      alt="sent in text message"
      role="presentation"
      src={presignedUrl}
      onClick={handleDownloadImage(contactFileId)}
      onError={handlePreviewError}
      className={`${
        isOnMobile ? 'u-maxWidth-200px' : 'u-maxWidth-400px'
      } u-margin-0Auto u-cursor-pointer`}
    />
  ) : (
    <div className="u-spread u-padding-y" style={{ borderTop: '1px solid #e0e0e0' }}>
      <div className="u-spread">
        <MaterialDesignIcon iconName={ICON_NAMES.DRAFT} />
        <div className="typo-body">{fileName}</div>
      </div>
      <UiButton size="xs" variant="tertiary" onClick={handleDownloadImage(contactFileId)}>
        Download
      </UiButton>
    </div>
  );
});
